// @ts-nocheck
import {
  Input as CInput,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  type FormLabelProps,
  HStack,
  type InputProps,
} from "@chakra-ui/react";
import { InputMask } from "@react-input/mask";
import type React from "react";
import { type FC, forwardRef } from "react";

export interface DateInputProps extends InputProps {
  name: string;
  onBlur?: () => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  label: string;
  helperText?: string;
  error?: string;
  labelProps?: FormLabelProps;
  isDisabled?: boolean;
  isRequired?: boolean;
  isInvalid?: boolean;
}

export const DateInput: FC<DateInputProps> = forwardRef(
  (
    {
      name,
      value,
      error,
      isInvalid,
      label,
      helperText,
      isDisabled = false,
      isRequired = false,
      onChange = () => {},
      labelProps = {},
      mb = "2",
      ...rest
    },
    ref,
  ) => {
    return (
      <FormControl isDisabled={isDisabled} isRequired={isRequired} isInvalid={isInvalid} mt="1" mb={mb}>
        <FormLabel mt="0" p="0" fontSize="md" {...labelProps}>
          {label}
        </FormLabel>
        <HStack spacing={2}>
          <InputMask
            ref={ref}
            component={CInput}
            name={name}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="MM/DD/YYYY"
            mask="MM/DD/YYYY"
            replacement={{ D: /\d/, M: /\d/, Y: /\d/ }}
            separate
            borderColor={isInvalid ? "red.500" : "gray.200"}
            {...rest}
          />
        </HStack>
        <FormErrorMessage>{error}</FormErrorMessage>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  },
);

DateInput.displayName = "DateInput";
